import { AppRouter } from "./routes/AppRouter"

export const AvaluoApp = () => {
  return (
    <>
      <AppRouter />
    </>
  )
}